import { isOnPage } from './utils';

function initCheckout() {
  if (!isOnPage('#checkout')) {
    return false;
  }

  const showLoader = (btn) => {
    btn.classList.add('btn--disabled');
    btn.querySelector('.ajax-loader').classList.add('ajax-loader--visible');
  };

  const hideLoader = (btn) => {
    btn.classList.remove('btn--disabled');
    btn.querySelector('.ajax-loader').classList.remove('ajax-loader--visible');
  };

  const checkoutForm = document.querySelector('#checkout-form');
  const checkoutSubmitBtn = document.querySelector('#checkout-submit');
  checkoutForm.addEventListener('submit', (e) => {
    e.preventDefault();

    $.ajax({
      method: 'POST',
      url: `${window.location.origin}/wp-json/motion/v1/order`,
      data: $(checkoutForm).serializeArray(),
      beforeSend() {
        showLoader(checkoutSubmitBtn);
        $('body').trigger('wc_placing_order');
      },
      success(data) {
        window.location = data.redirect_url;
      },
      error(data) {
        console.log(data);
      },
      complete() {
        hideLoader(checkoutSubmitBtn);
      },
    });
  });

  return true;
}
initCheckout();
